import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import {
    FaFileSignature,
    FaUserShield,
    FaArrowLeft
} from 'react-icons/fa';
import { MdReport } from 'react-icons/md';
import { IoSettingsOutline } from 'react-icons/io5';
import { FiBell } from 'react-icons/fi';
import '../styles/home.scss';

export const Home = () => {
    const user = useSelector(state => state.userController.user);
    const navigate = useNavigate();

    useEffect(() => {
        if (!user) {
            navigate('/login');
        }
    }, [navigate, user]);

    const access = user?.access || [];

    const dashboardCards = [
        {
            id: 'applications',
            title: 'طلبات التجنيد',
            icon: <FaFileSignature />,
            label: 'عرض وفلترة طلبات المتقدمين',
            link: '/applications',
            color: '#215ABD',
            show: access.includes('applications') || access.includes('owner')
        },
        {
            id: 'notifications',
            title: 'الإشعارات',
            icon: <FiBell />,
            label: 'إرسال إشعارات للمتقدمين حسب الفلترة',
            link: '/notifications',
            color: '#0e9f6e',
            show: access.includes('notifications') || access.includes('owner')
        },
        {
            id: 'reports',
            title: 'التقارير',
            icon: <MdReport />,
            label: 'قريباً',
            link: '/reports',
            color: '#7c3aed',
            show: access.includes('reports') || access.includes('owner')
        },
        {
            id: 'settings',
            title: 'الإعدادات',
            icon: <IoSettingsOutline />,
            label: 'التحكم بمحتوى الصفحة الرئيسية',
            link: '/settings',
            color: '#7f8c8d',
            show: access.includes('settings') || access.includes('owner')
        },
        {
            id: 'admins',
            title: 'المسؤولين',
            icon: <FaUserShield />,
            label: 'قريباً',
            link: '/admins',
            color: '#34495e',
            show: access.includes('owner')
        }
    ];

    const visibleCards = dashboardCards.filter(card => card.show);

    return (
        <section className='container home'>
            <div className="dashboard-grid">
                {visibleCards.map(card => (
                    <Link
                        key={card.id}
                        to={card.link}
                        className="dashboard-card"
                        style={{ '--card-color': card.color }}
                    >
                        <div className="card-header">
                            <div className="card-icon" style={{ color: card.color }}>
                                {card.icon}
                            </div>
                            <h3>{card.title}</h3>
                        </div>

                        <div className="card-body">
                            <div className="card-label">{card.label}</div>
                        </div>

                        <div className="card-footer">
                            <span>عرض المزيد</span>
                            <FaArrowLeft />
                        </div>
                    </Link>
                ))}
            </div>

            {visibleCards.length === 0 && (
                <div className="no-access">
                    <p>لا توجد صفحات متاحة لك</p>
                </div>
            )}
        </section>
    );
};

export default Home;
